/**
 * Created by hernanherreros on 2019-05-27
 */

import * as React from 'react'
import styled from 'styled-components'
import { Spin } from 'antd'

interface Props {
  isLoading?: boolean;
  children: any;
  size: 'small' | 'default' | 'large';
  over?: boolean;
}

const LoaderWrapper = ({ children, isLoading, over, size }: Props) => {
  const loader = (
    <SpinWrapper>
      <Spin size={size}/>
    </SpinWrapper>
  )

  return (
    <Container withHeight={!over}>
      {!isLoading || over ? children : null}
      {isLoading && loader}
    </Container>
  )
}

const Container = styled.div<any>`
  position: relative;
  
  ${({ withHeight }) => withHeight && 'min-height: 500px;' }
`

const SpinWrapper = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 99;
`

LoaderWrapper.defaultProps = {
  over: true,
  size: 'default',
}

export default LoaderWrapper